import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CalendarCheck, Loader2 } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Deal close date — drives financial-year reporting (FY from the Selling Entity's FY start month). Auto-filled when the deal is marked Won. */
export function DealCloseDateCard({ estimateId, estimate, canEdit, onSaved }) {
  const [val, setVal] = useState(estimate?.deal_close_date || '');
  const [fy, setFy] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setVal(estimate?.deal_close_date || ''); }, [estimate?.deal_close_date]);
  const dirty = (val || '') !== (estimate?.deal_close_date || '');
  const save = async (clear = false) => {
    setBusy(true);
    try {
      const r = await axios.patch(`${API_URL}/api/estimates/${estimateId}/deal-close-date`, { deal_close_date: clear ? null : val || null }, { withCredentials: true });
      setFy(r.data.fy); if (clear) setVal('');
      toast.success(clear ? 'Deal close date cleared' : `Deal close date saved${r.data.fy ? ` — ${r.data.fy}` : ''}`);
      onSaved?.(r.data);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not save the close date'); } finally { setBusy(false); }
  };
  return (
    <Card className="border-slate-200" data-testid="deal-close-date-card">
      <CardContent className="p-4 flex flex-wrap items-end gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-1 text-slate-400 text-[10px] mb-1"><CalendarCheck className="w-3 h-3" />Deal close date</div>
          <p className="text-[10px] text-slate-400">Used to assign this deal to a financial year in Insights (ARR, revenue). Auto-filled when the deal is marked Won.</p>
        </div>
        <Input type="date" value={val} onChange={(e) => setVal(e.target.value)} disabled={!canEdit || busy} className="h-8 text-xs w-40" data-testid="deal-close-date-input" />
        {canEdit && <Button size="sm" onClick={() => save(false)} disabled={!dirty || busy} className="h-8 bg-[#0F2040] hover:bg-[#1a3260] text-white" data-testid="deal-close-date-save">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : 'Save'}</Button>}
        {canEdit && estimate?.deal_close_date && <Button size="sm" variant="ghost" onClick={() => save(true)} disabled={busy} className="h-8 text-slate-500" data-testid="deal-close-date-clear">Clear</Button>}
        {(fy || estimate?.deal_close_date) && <span className="text-[11px] text-slate-500" data-testid="deal-close-date-fy">{fy ? `Financial year ${fy}` : `Closes ${estimate.deal_close_date}`}</span>}
      </CardContent>
    </Card>
  );
}
